import styles from './Login.module.scss';
import { useState, useEffect } from "react"
import {connect} from "react-redux";
import { $getLanguages, $t } from "../../../helpers/translator";
import cookiesLang from "../../../helpers/cookies";
import api from "../../../helpers/api";
import _ from 'lodash';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';
import { FaPlayCircle } from 'react-icons/fa';
import { Link, useHistory } from 'react-router-dom';
import MultiSelect from '../../../components/miscellaneous/MultiSelect/MultiSelect';
import Loader from '../../../components/miscellaneous/Loader/Loader';
import {useDispatch} from "react-redux";
import {login, getUser, getUserClinic, loginWithToken} from "../../../store/auth-slice";
import { useGoogleLogin } from 'react-google-login'
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import GuideModal from '../../../components/miscellaneous/GuideModal/GuideModal';

const appVersion = process.env.REACT_APP_VERSION;

const Login = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState(null);
    const [sent, setSent] = useState(false);
    const [isMobileApp, setIsMobileApp] = useState(false);
    const [languages, setLanguages] = useState([]);
    const [selectedLanguage, setSelectedLanguage] = useState({
        label: 'English',
        value: 'en'
    });
    const [socialLogin, setSocialLogin] = useState({
        enabled: true,
        provider: null,
        token: null
    });

    const [data, setData] = useState({
        email: {
            value: '',
            error: '',
            touched: false,
            rules: [
                {
                    regex: /^.{3,}$/,
                    errorText: $t('validation.general.minLength', ['3'])
                },
                {
                    regex: /^(?!\s*$).+$/,
                    errorText: $t('validation.general.required')
                },
            ]
        },
        password: {
            value: '',
            error: '',
            touched: false,
            rules: [
                {
                    regex: /^.{3,}$/,
                    errorText: $t('validation.general.minLength', ['3'])
                },
                {
                    regex: /^(?!\s*$).+$/,
                    errorText: $t('validation.general.required')
                },
            ]
        }
    });
    const [showGuideModal, setShowGuideModal] = useState(false);

    const { signIn } = useGoogleLogin({
        clientId: '305979167531-jdoeb0h72e6oga1arfiteeg6oonrdh45.apps.googleusercontent.com',
        onSuccess: (response) => {
            const {tokenId} = response;
            setSocialLogin({...socialLogin, token: tokenId, provider: 'google'});
        },
        onFailure: (response) => {
            console.error(response);
            setLoading(false);
        }
    });

    // const oldProjectRoles = [ ]

    const isUsingMobileApp = () => {
        try {
            const userAgent = window.clientInformation.userAgent;
            return userAgent.includes('GoNative') || userAgent.includes('gonative');
        } catch(e) {
            return false;
        }
    }

    const languageChangeHandler = (data) => {
        setSelectedLanguage(data);
        cookiesLang.utils.setLang(data.value);
        localStorage.setItem('almaLang', data.value);
        window.location.reload();
    }

    const fieldChangeHandler = (fieldName, e) => {
        let newData = { ...data };
        newData[fieldName].value = e.target.value;
        newData[fieldName].touched = true;
        newData[fieldName].error = '';
        newData[fieldName] = validateField(newData[fieldName])

        setData(newData);
        setError(null)
    }

    const doLogin = async() => {
        let payload = {
            email: data.email.value,
            password: data.password.value,
        };

        setLoading(true);
        let loginError = null;
        try {
            let res = await dispatch(login(payload));
            // console.log('>>>rrres', res)
            if (res && res.success) {
                let user = await dispatch(getUser());
                history.push('/');
                if (user.role === 2 || user.role === 3) {
                    let userRes = await dispatch(getUserClinic());
                }
            } else {
                loginError = res.errorText;
            }
        } catch (e) {
            loginError = e.errorText ? e.errorText : `An error occurred`;
        } finally {
            setLoading(false);
            setError(loginError);
        }
    }

    const submitHandler = async(e) => {
        e.preventDefault()

        let newData = { ...data };
        let validated = true;
        let loginError = '';

        _.forEach(newData, (v, k) => {
            v.touched = true;
            newData[k] = validateField(v);
            if (newData[k].error) {
                validated = false;
                loginError = $t('validation.more.someOfTheFieldsContainErrors')
            }
        });

        setData(newData);
        setError(loginError)
        setSent(true)

        if(!validated) {
            return;
        }

        await doLogin();
    }

    const validateField = (v) => {
        let field = { ...v };

        _.forEach(field.rules, (rule, rk) => {
            if (!rule.regex.test(field.value)) {
                field.error = rule.errorText;
            }
        });

        return field;
    }

    const doSocialAuth = async({provider, context}) => {
        if(socialLogin.enabled === true) {
            setLoading(true);
            setSocialLogin({...socialLogin, provider: provider});
            if(provider === 'google') {
                signIn();
            } else if(provider === 'facebook') {
                context.onClick();
            }
        } else {
            alert(`Can not login with ${provider}. Please disable any browser blockers and make sure cookies are enabled!`);
        }
    }

    useEffect(() => {
        // Get current language
        const currentLang = localStorage.getItem('almaLang') ? localStorage.getItem('almaLang') : 'en';
        const langs = [];
        _.forEach($getLanguages(), (v, k) => {
            langs.push({
                label: v,
                value: k
            });
        });

        // let windowUrl = window.location.href;
        // if (windowUrl && windowUrl.includes('video-guide=true')) {
        //     setShowGuideModal(true)
        // }

        // Find index of selected lanaguage
        let i = _.findIndex(langs, function (o) {
            return o.value === currentLang;
        });

        setSelectedLanguage(langs[i]);
        setLanguages(langs);
        setIsMobileApp(isUsingMobileApp());
    }, [])

    useEffect(async() => {
        if(socialLogin.token != null) {
            await doSocialLogin();
        }
    }, [socialLogin]);

    const doSocialLogin = async() => {
        const redirectTo = await api.post(`/auth/oauth/verify/${socialLogin.provider}`, {
            token: socialLogin.token
        }).then(async(res) => {
            const {success, data} = res.data;
            if(success === true) {
                const mode = data.mode;
                const userData = data.data;

                if(mode === 'login') {
                    const redirectUrl = await dispatch(loginWithToken(userData.access_token)).then(async(auth) => {
                        await dispatch(getUser());
                        const user = auth.data;
                        if (!user.access_token) {
                            return '/login';
                        } else {
                            //login successful
                            if (user.role === 2 || user.role === 3) {
                                await dispatch(getUserClinic());
                            }
                        }

                        return '/dashboard'
                    });

                    return redirectUrl;
                } else if(mode === 'register') {
                    return `/register?uId=${userData.uid}&email=${userData.email}&name=${userData.name}&picture=${encodeURIComponent(userData.picture)}`;
                }
            }

        })
        .finally(() => {
            setSocialLogin({...socialLogin, token: null, provider: null});
            setLoading(false);
        });

        if(redirectTo) {
            // console.log(redirectTo);
            history.push(redirectTo);
        }
    }

    const renderForm = () => {
        return (
            <div className={styles.formContainer}>
                <div className={styles.form}>
                    <div className={styles.welcome}>{$t('global.login.welcome')}</div>
                    <form className={styles.loginForm} action="" onSubmit={(e) => submitHandler(e)}>
                        <div className={styles.fieldContainer}>
                            <div className={styles.passwordContainer}>
                                <input name="email"
                                   className={`alma-input full ${(sent && data.email.error && data.email.touched ? styles.almaInputError : '')}`}
                                   type="text"
                                   value={data.email.value}
                                   placeholder={$t('global.login.email')}
                                   onChange={(e) => fieldChangeHandler('email', e)}/>
                            </div>
                            <div className={styles.error}>
                                {data.email.error}
                            </div>
                        </div>

                        <div className={styles.fieldContainer}>
                            <div className={styles.passwordContainer}>
                                <input name="password"
                                       style={{ position: 'relative' }}
                                       className={`alma-input full ${(sent && data.password.error && data.password.touched ? styles.almaInputError : '')}`}
                                       type={showPassword ? 'text' : 'password'}
                                       value={data.password.value}
                                       placeholder={$t('global.login.password')}
                                       onChange={(e) => fieldChangeHandler('password', e)}/>
                                {
                                    showPassword ?
                                        <AiOutlineEyeInvisible
                                            className={styles.eyeIcon}
                                            color={'#343434'}
                                            onClick={() => setShowPassword(!showPassword)}
                                        />
                                        :
                                        <AiOutlineEye
                                            className={styles.eyeIcon}
                                            onClick={() => setShowPassword(!showPassword)}
                                        />
                                }
                            </div>
                            <div className={styles.error}>
                                {sent ? data.password.error : ''}
                            </div>
                        </div>
                        <div className={styles.sendButtonContainer}>
                            <button type={"submit"} className={`secondary-button ${styles.sendButton}`}  onSubmit={(e) => submitHandler(e)}>
                                {$t('global.login.signIn')}
                            </button>
                        </div>
                        <div className={styles.flex}>
                            <div className={styles.forgotPasswordRow}>
                                <Link to={'forgot-password'}>{$t('global.login.forgotPassword')}</Link>
                            </div>
                            <div className={`${styles.error} ${styles.flexGrow}`} style={{padding: '5px 10px'}}>
                                {sent ? error : ''}
                            </div>
                        </div>
                        <div className={styles.socialButtonsWrapper} style={{margin: '10px 0'}}>
                            <hr style={{width:'100%', opacity: '40%'}}/>
                        </div>
                        <div className={styles.socialButtonsWrapper}>
                            <button onClick={(e) => {
                                e.preventDefault();
                                doSocialAuth({provider: 'google'})
                                }} className={`g-signin2 ${styles.socialButton}`} style={{background: '#4285f4'}}>
                                <img src="assets/google.svg" /> Sign In with Google</button>
                            <FacebookLogin
                                appId="650211496227100"
                                fields="name,email,picture"
                                autoLoad={false}
                                callback={(e) => {
                                    setLoading(false);
                                    console.error(e)
                                    const {accessToken} = e;
                                    setSocialLogin({...socialLogin, token: accessToken, provider: 'facebook'});
                                }}
                                render={renderProps => (
                                    <button onClick={(e) => {
                                        e.preventDefault();
                                        doSocialAuth({provider: 'facebook', context: renderProps})
                                        }} className={styles.socialButton} style={{background: '#000000'}}>
                                        <img style={{background: 'transparent', padding: 0}} src="assets/facebook.svg" /> Sign In with Facebook
                                    </button>
                                )}
                            />
                        </div>
                    </form>
                </div>
            </div>
        );
    }

    const accountLogo = '/assets/alma_logo_w.png';

    return (
        <>
            <GuideModal show={showGuideModal} onClose={() => {
                setShowGuideModal(false);
            }} />
            <div className={styles.pageContainer}>
                <div className={styles.loginContainer}>
                    <div className={styles.sidePart}>
                        <div className={styles.circle}
                                style={{ backgroundImage: `url(${accountLogo})` }}/>
                        <div className={styles.version} onClick={() => {
                            // dispatch(setAlert({header: 'Customizable header', type: 'success' , duration: 10000, body: 'Optional explanation text'}))
                        }}>
                            {appVersion}
                        </div>
                    </div>
                    <div className={styles.mainPart}>
                        {
                            loading ?
                                <div className={styles.loaderContainer}>
                                    <Loader/>
                                </div>
                                :
                                null
                        }
                        <div className={styles.topRow}>
                            <div className={styles.topRowRight}>
                                <div style={{ marginRight: '10px' }}>
                                    <a href="#" onClick={(e) => {
                                        e.preventDefault();
                                        setShowGuideModal(true);
                                    }} className={styles.goToGuide}>
                                        {$t('global.login.guide')}
                                        <FaPlayCircle style={{
                                            fontSize: '25px',
                                            marginLeft: '5px'
                                        }}/>
                                    </a>
                                </div>
                                <div style={{ width: '120px' }}>
                                    <MultiSelect
                                        options={languages}
                                        selected={selectedLanguage}
                                        onValueChange={(data) => languageChangeHandler(data)}
                                    />
                                </div>
                            </div>

                            <div className={styles.topRowLeft}>
                                <div>
                                    {$t('global.login.dontHaveAnAccount')} <Link
                                    to="register">{$t('global.login.register')}</Link>
                                </div>

                            </div>
                        </div>
                        <div className={styles.middleRow}>
                            {renderForm()}
                        </div>

                        <div className={styles.bottomRow}>
                            <div className={styles.terms}>
                                <a href="/#/content/terms" target="_blank" rel="noreferrer">Terms of Service</a>
                                <span>•</span>
                                <a href="/#/content/privacy" target="_blank" rel="noreferrer">Privacy Policy</a>
                            </div>
                            <img style={{ width: '200px', opacity:'0.9' }} src="assets/alma-logo-purple.svg" alt="Smart Clinic"/>
                        </div>
                    </div>
                </div>
                {!isMobileApp && <div className={styles['mobileApp']}>
                    <a href="https://apps.apple.com/ph/app/alma-smart-clinic/id1581397522" target="_blank" rel="noreferrer"><img width={180} src='assets/appstore.svg' alt='' className={styles.mobileAppImg} /></a>
                    <a href="https://play.google.com/store/apps/details?id=io.gonative.android.alpbmr&hl=en&gl=US" target="_blank" rel='noreferrer'><img width={180} src='assets/googleplay.svg' className={styles.mobileAppImg} alt='' /></a>
                </div> }
            </div>
        </>
    );
}

const mapStateToProps = (actions) => ({
    actions: actions
});

export default connect(mapStateToProps)(Login);
